// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__r5OLR","sendOtp":"AuthorizeToLogin_sendOtp__2l3dm"};